import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_6 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_7 = {
  for: "company-name",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_8 = { class: "mt-10 flex justify-between" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "flex flex-row-reverse" }

import { ref, onMounted, computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ProcessTemplateActions } from "@/store/modules/processTemplate/actions";
import { ProcessTemplateGetters } from "@/store/modules/processTemplate/getters";
import { PencilIcon } from "@heroicons/vue/solid";
import {
  DotsHorizontalIcon,
  PlusIcon,
  SearchIcon,
} from "@heroicons/vue/outline";
import VueTableLite from "vue3-table-lite/ts";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { ActionMenu } from "@/components/common";
import ProcessTemplateTypeLabel from "@/components/documents/ProcessTemplateTypeLabel.vue";
import { Button } from "@/components/common";
import { t } from "@/i18n";
import ProcessTemplate from "@/types/documents/process/ProcessTemplate";
import { ProcessTemplateTypesEnum } from "@/store/modules/processTemplate/state";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();

const dataProvider = computed(() => {
  return store.getters[ProcessTemplateGetters.GET_DATA_PROVIDER];
});
const processTemplates = computed(() => {
  return dataProvider.value.items;
});
const pager = computed(() => {
  return dataProvider.value.pager;
});

const systemProcessTranslationKeys = {
  name: {
    "На согласование": "processTemplateList.system.name.approval",
    "На подписание": "processTemplateList.system.name.signing",
    "На доработку": "processTemplateList.system.name.rework",
    Доработать: "processTemplateList.system.name.rework",
  },
  actionName: {
    Согласовать: "processTemplateList.system.action.approval",
    Подписать: "processTemplateList.system.action.signing",
    Доработать: "processTemplateList.system.action.rework",
  },
} as const;

const localizedSystemProcessValue = (
  process: ProcessTemplate,
  field: "name" | "actionName"
) => {
  const value = process[field];
  if (process.type !== ProcessTemplateTypesEnum.SYSTEM) {
    return value;
  }

  const translationKey =
    systemProcessTranslationKeys[field][
      value as keyof (typeof systemProcessTranslationKeys)[typeof field]
    ];
  return translationKey ? t(translationKey) : value;
};

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: t("common.title"),
      field: "name",
      sortable: false,
    },
    {
      label: t("processTemplateList.column.actionName"),
      field: "actionName",
      sortable: false,
    },
    {
      label: t("common.type"),
      field: "type",
      sortable: false,
    },
    {
      label: t("processTemplateList.column.position"),
      field: "position",
      sortable: false,
    },
    {
      label: "",
      field: "action",
      sortable: false,
    },
  ],
  rows: processTemplates,
  totalRecordCount: 0,
});

const dropDownActions = [
  {
    text: t("processTemplateList.action.edit"),
    icon: PencilIcon,
    iconColor: "text-green-500",
    action: (id: string) => {
      router.push({ name: "ProcessTemplateEdit", params: { id: id } });
    },
  },
];

const getPage = async (page: number) => {
  await store.dispatch(ProcessTemplateActions.FETCH_DATA_PROVIDER, {
    page: page,
  });
};

// Filter
const filter = ref({
  name: "",
});
const updateFilter = async () => {
  try {
    await store.dispatch(
      ProcessTemplateActions.FETCH_DATA_PROVIDER,
      filter.value
    );
  } catch (e) {
    console.log(e);
  }
};

onMounted(async () => {
  await store.dispatch(ProcessTemplateActions.FETCH_DATA_PROVIDER, {
    page: 1,
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("processTemplateList.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("common.name")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "company-name",
            type: "search",
            class: "input-form w-full",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.name) = $event))
          }, null, 512), [
            [_vModelText, filter.value.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(Button), {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (updateFilter())),
          class: "btn-search"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.search")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: { name: 'ProcessTemplateCreate' } }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), { class: "flex px-10" }, {
              default: _withCtx(() => [
                _createVNode(_unref(PlusIcon), { class: "button-icon mr-2" }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.create")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_unref(VueTableLite), {
      "data-pagination-scroll-anchor": "",
      "is-slot-mode": true,
      "is-loading": _unref(table).isLoading,
      columns: _unref(table).columns,
      rows: _unref(table).rows,
      total: _unref(table).totalRecordCount,
      sortable: false,
      "is-hide-paging": true,
      messages: { noDataAvailable: _unref(t)('common.noData') }
    }, {
      name: _withCtx((data) => [
        _createTextVNode(_toDisplayString(localizedSystemProcessValue(data.value, "name")), 1)
      ]),
      actionName: _withCtx((data) => [
        _createTextVNode(_toDisplayString(localizedSystemProcessValue(data.value, "actionName")), 1)
      ]),
      type: _withCtx((data) => [
        _createVNode(ProcessTemplateTypeLabel, {
          label: data.value.type
        }, null, 8, ["label"])
      ]),
      action: _withCtx((data) => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(ActionMenu), {
            actions: dropDownActions,
            item: data.value
          }, null, 8, ["item"])
        ])
      ]),
      _: 1
    }, 8, ["is-loading", "columns", "rows", "total", "messages"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(TablePagination, {
        current: _unref(pager).currentPage,
        "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((_unref(pager).currentPage) = $event)),
        "total-pages": _unref(pager).totalPages,
        "onUpdate:total-pages": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pager).totalPages) = $event)),
        "start-page": _unref(pager).startPage,
        "end-page": _unref(pager).endPage,
        onPageChanged: getPage
      }, null, 8, ["current", "total-pages", "start-page", "end-page"])
    ])
  ]))
}
}

})